import { LinesWithBreaks } from "./LinesWithBreaks";

interface Props {
  text: string;
}

export const TextWithBreaks = ({ text }: Props) =>
  !text ? <></> : <LinesWithBreaks lines={text.trim().split("\n")} />;
